<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>{{ $route.meta.name }}管理</el-breadcrumb-item>
      <el-breadcrumb-item>{{ $route.meta.name }}列表</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="row">
      <div class="col-sm-12">
        <div class="panel">
          <div>
            <div class="filter">
              <el-form
                :inline="true"
                :model="filter"
                ref="filterForm"
                label-position="right"
                label-width="80px"
                class="search-form"
                size="small"
              >
                <el-form-item label="仓库" prop="stockroom_id" v-if="!admin">
                  <stockroom-select
                    :val="filter.stockroom_id"
                    @change="filter.stockroom_id = $event"
                  ></stockroom-select>
                </el-form-item>
                <el-form-item label="关键字" prop="name">
                  <el-input v-model="filter.name" placeholder="名称"></el-input>
                </el-form-item>
                <br />
                <el-form-item
                  label="查询范围"
                  prop="all_stockroom"
                  v-if="admin"
                >
                  <el-checkbox v-model="filter.all_stockroom"
                    >所有仓库</el-checkbox
                  >
                </el-form-item>
              </el-form>
              <div style="margin-left: 80px">
                <el-button
                  type="primary"
                  size="small"
                  @click="
                    page = 1
                    getData()
                  "
                  >筛选</el-button
                >
                <el-button size="small" @click="reset()">重置</el-button>
              </div>
            </div>
          </div>
        </div>
        <div class="panel">
          <!-- <btn-tag
            v-if="admin"
            :btn="true"
            text="添加复合片"
            :auth-id="51201"
            btn-class="btn-purple"
            icon-class="ion-plus-circled"
            module-name="stock"
            @click.native="formerVisible = true"
          ></btn-tag> -->
          <item-table
            :items="items.list"
            :admin="admin"
            v-loading="loading"
          ></item-table>
          <pagination
            :records="items.count"
            :page="page"
            :per-page="20"
            @paginate="loadData"
          ></pagination>
        </div>
      </div>
    </div>
    <pdc-former
      :model="model"
      :show.sync="formerVisible"
      @created="createdCallback"
    ></pdc-former>
  </div>
</template>

<script>
import { pdcList } from '@/service/getData'
import ItemTable from './table'
import PdcFormer from '@/components/pdc_former'
import { getStore } from '@/config/mUtils'
import StockroomSelect from '@/components/select/stockroom_select'

export default {
  components: {
    ItemTable,
    PdcFormer,
    StockroomSelect,
  },
  data() {
    return {
      loading: false,
      filter: { stockroom_id: '', name: '', all_stockroom: false },
      admin: getStore('userInfo').is_stockroom_admin,
      model: {
        commodity_id: '',
        specification: '',
        chamfering: '',
        serial_number: '',
        diameter: '',
        tooth_type: '',
        grade: '',
      },
      formerVisible: false,
      page: 1,
      items: {
        list: [],
        count: 0,
      },
    }
  },
  created() {
    this.getData()
  },
  methods: {
    reset() {
      this.$refs['filterForm'].resetFields()
      this.page = 1
      this.getData()
    },
    async getData() {
      let data = {
        page: this.page - 1,
        stockroom_id: this.filter.stockroom_id,
        query: this.filter.name,
        all_stockroom: this.filter.all_stockroom,
      }
      this.loading = true
      let res = await pdcList(data)
      if (res.status != 0) return
      this.items = res.data
      this.loading = false
    },
    async loadData(page) {
      this.page = page
      this.getData()
    },
    createdCallback(item) {
      this.items.list.unshift(item)
    },
  },
}
</script>